import type { AgentActivity } from "@/sdk";

export default function getAgentStateByActivity(agent: connect.Agent, activity: AgentActivity) {
    const state = agent.getAgentStates().find(({ name }) => name === activity);
    if (!state) throw new Error(`Activity ${activity} doesn't exist as an agent state in Amazon Connect instance`);
    return state;
}
